import {
  GreyGrey60,
  GreyGrey90,
  IconCircleInfo,
  IndigoIndigo60,
  Link,
  Popover,
  Primary13Regular,
  Primary13SemiBold,
  SwitchLineInput,
  Box,
  Flex
} from '@sequencehq/core-components'
import { usePhaseActions } from './usePhaseActions'

export const PhaseRecurrenceSwitch = (props: { phaseId: string }) => {
  const phaseActions = usePhaseActions({ phaseId: props.phaseId })

  if (!phaseActions.phaseRecurrencePreference.visible) {
    return null
  }

  return (
    <Flex
      {...Primary13Regular}
      color={GreyGrey90}
      gap="8px"
      alignItems="center"
      height="100%"
    >
      <SwitchLineInput
        data-testid="phase.recurrencePreference"
        isDisabled={!phaseActions.phaseRecurrencePreference.available}
        value={phaseActions.phaseRecurrencePreference.value === 'RESET'}
        onChange={newValue =>
          phaseActions.phaseRecurrencePreference.handler(
            newValue ? 'RESET' : 'CONTINUE_FROM_PREVIOUS_PHASE'
          )
        }
        text={'Reset billing period'}
      />
      <Popover
        content={
          <Box>
            <Box {...Primary13SemiBold} color={GreyGrey90} marginBottom="8px">
              Reset billing period
            </Box>
            <Box {...Primary13Regular} color={GreyGrey90}>
              Enable this to start new billing periods for all prices from here.
              Otherwise, existing billing periods will continue as before.
              <Link
                to="https://docs.sequencehq.com/billing/billing-schedule-phases#reset-billing-periods"
                isExternal
                color={IndigoIndigo60}
                marginLeft="4px"
              >
                Learn more
              </Link>
            </Box>
          </Box>
        }
      >
        <IconCircleInfo color={GreyGrey60} />
      </Popover>
    </Flex>
  )
}
